export default Object.freeze({
    //QORANI_BACKEND_SERVICES: "http://localhost:8083/",
    QORANI: "https://qorani-qorani-recette.gbapgy.easypanel.host/",
    //QORANI: "http://192.168.0.57:8080/",
    //QORANI: "https://qorani-qorani-backend-test.gbapgy.easypanel.host/",
    //QORANI: "https://backendqorani.mercarue.com/",
});